import React, { useEffect, useState } from 'react';
import logo from "../../assets/Statgrit_logo_main.png"
import IconCollection from '../../IconCollection/IconCollection';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { jwtDecode } from "jwt-decode";
import NotificationPanel from '../NotificationPanel/NotificationPanel';
const Navbar = () => {
  const [notificationPanel, setNotificationPanel] = useState(false)
  const userState = useSelector((state) => state.fotogritReducer);
  const userName = userState?.user_data?.fullname;
  const image_profile = userState?.user_data?.image_profile;
  const token = window.localStorage.getItem("token");

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (notificationPanel && !event.target.closest('.notification-panel')) {
        setNotificationPanel(false);
      }
    };

    if (notificationPanel) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.body.style.overflow = '';
      document.removeEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [notificationPanel]);

  const handleNotificationPanel = () => {
    setNotificationPanel(true);
  };
  let userData;
  if (token) {
     userData = jwtDecode(token);
  }
  const { notifications } = useSelector((state) => state.notificationReducer);


  return (
    <nav className=' w-full  bg-[#1A1A1A] mx-auto'>
      <div className='max-w-[1512px] h-[100px] px-6 sm:px-12 w-full mx-auto flex justify-between items-center relative '>
        <div className='flex items-center gap-4'>
          <Link to="/" className='max-w-16 w-full h-[76px] cursor-pointer'>
            <img src={logo} className='w-full scale-[1.9]' alt="logo" />

          </Link>
          <p className='text-light md:block  hidden font-montserrat font-medium text-xs lg:text-base xl:text-2xl uppercase'>FOTOGRIT SCORING TOOL - <span className='text-secondary'>Basketball 5x5</span> </p>

        </div>
        {
          token && <div className='flex items-center gap-4 sm:gap-6'>
            <button onClick={() => handleNotificationPanel()} className='max-w-12 w-full h-12  cursor-pointer relative'>
              <div className='top-0 right-0  w-6 h-6 leading-none bg-primary text-white text-[10px] flex justify-center
              items-center rounded-[100%] font-montserrat font-medium absolute'>{notifications?.length > 99 ? '99+' : notifications?.length}</div>
              <IconCollection customClass="w-14 h-14" className="" name="notifications_with_dot" />
            </button>
            <Link to="/settings" className='max-w-12 w-full h-12  cursor-pointer'>
              <IconCollection name="setting" />
            </Link>
            <div className='flex items-center gap-3'>
              <Link to="user-setting" className='max-w-12 w-full h-12 rounded-full cursor-pointer'>
                {
                  image_profile ?  <img src={image_profile} className='w-full rounded-full' alt="logo" /> : <IconCollection name="user-default-icon"/>
                }


              </Link>

              <p className='hidden md:block font-montserrat text-xs md:text-sm xl:text-xl text-dark_gray font-medium'>{userName}</p>

            </div>
          </div>
        }

        <NotificationPanel notificationPanel={notificationPanel}  />
      </div>
    </nav>
  );
};

export default Navbar;